export default {
  wrapper: {
    base: {
      paddingTop: '10px',
      paddingRight: 'xs',
      paddingBottom: 'sm',
      paddingLeft: '15px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: '4px',
      width: ['290px', '356px', '608px'],
      marginLeft: 'auto',
      marginRight: 'auto',
      fontFamily: 'base',
      color: '#000000',
      variant: 'spark.base.wrapper'
    },
    variants: {
      information: {
        variant: 'spark.element.toast.wrapper.base',
        backgroundColor: 'blue_100',
        borderColor: 'blue_700'
      },
      error: {
        variant: 'spark.element.toast.wrapper.base',
        bg: 'red_50',
        border: 'red_500'
      },
      warning: {
        variant: 'spark.element.toast.wrapper.base',
        backgroundColor: 'yellow_100',
        borderColor: 'yellow_700'
      },
      success: {
        variant: 'spark.element.toast.wrapper.base',
        backgroundColor: 'green_50',
        border: 'green_800'
      },
      default: {
        variant: 'spark.element.toast.wrapper.base',
        backgroundColor: 'grey-10',
        borderColor: 'grey-50'
      }
    }
  },
  header: {
    base: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '7px'
    },
    variants: {
      information: {
        variant: 'spark.element.toast.header.base'
      },
      error: {
        variant: 'spark.element.toast.header.base'
      },
      warning: {
        variant: 'spark.element.toast.header.base'
      },
      success: {
        variant: 'spark.element.toast.header.base'
      },
      default: {
        variant: 'spark.element.toast.header.base'
      }
    }
  },
  title: {
    base: {
      marginLeft: '6px',
      marginRight: '15px',
      lineHeight: '24px'
    },
    variants: {
      information: {
        variant: 'spark.element.toast.title.base'
      },
      error: {
        variant: 'spark.element.toast.title.base'
      },
      warning: {
        variant: 'spark.element.toast.title.base'
      },
      success: {
        variant: 'spark.element.toast.title.base'
      },
      default: {
        variant: 'spark.element.toast.title.base',
        marginLeft: '0'
      }
    }
  },
  iconContainer: {
    base: {
      height: '24px'
    },
    variants: {
      information: {
        variant: 'spark.element.toast.iconContainer.base'
      },
      error: {
        variant: 'spark.element.toast.iconContainer.base'
      },
      warning: {
        variant: 'spark.element.toast.iconContainer.base'
      },
      success: {
        variant: 'spark.element.toast.iconContainer.base'
      },
      default: {
        variant: 'spark.element.toast.iconContainer.base'
      }
    }
  },
  icon: {
    base: {
      display: 'block',
      width: '24px',
      height: '24px'
    },
    variants: {
      information: {
        variant: 'spark.element.toast.icon.base'
      },
      error: {
        variant: 'spark.element.toast.icon.base'
      },
      warning: {
        variant: 'spark.element.toast.icon.base'
      },
      success: {
        variant: 'spark.element.toast.icon.base'
      },
      default: {
        variant: 'spark.element.toast.icon.base'
      }
    }
  },
  timer: {
    base: {
      color: 'grey-60',
      marginRight: '10px'
    },
    variants: {
      information: {
        variant: 'spark.element.toast.timer.base'
      },
      error: {
        variant: 'spark.element.toast.timer.base'
      },
      warning: {
        variant: 'spark.element.toast.timer.base'
      },
      success: {
        variant: 'spark.element.toast.timer.base'
      },
      default: {
        variant: 'spark.element.toast.timer.base'
      }
    }
  },
  closeButton: {
    base: {
      display: 'block',
      mr: '0',
      ml: '0',
      position: 'relative',
      width: '24px',
      height: '24px',
      p: 0,
      border: 'none',
      cursor: 'pointer',
      color: 'unset',
      backgroundColor: 'transparent',
      appearance: 'none'
    },
    variants: {
      information: {
        variant: 'spark.element.toast.closeButton.base'
      },
      error: {
        variant: 'spark.element.toast.closeButton.base'
      },
      warning: {
        variant: 'spark.element.toast.closeButton.base'
      },
      success: {
        variant: 'spark.element.toast.closeButton.base'
      },
      default: {
        variant: 'spark.element.toast.closeButton.base'
      }
    }
  },
  content: {
    base: {
      color: 'grey-70',
      marginLeft: '1px',
      marginRight: 'xxxs'
    },
    variants: {
      information: {
        variant: 'spark.element.toast.content.base'
      },
      error: {
        variant: 'spark.element.toast.content.base'
      },
      warning: {
        variant: 'spark.element.toast.content.base'
      },
      success: {
        variant: 'spark.element.toast.content.base'
      },
      default: {
        variant: 'spark.element.toast.content.base'
      }
    }
  }
};